import { memo } from 'react';
    
import s from './Loader.module.scss';

interface ILoaderProps {}

export const Loader = memo((props: ILoaderProps) => {
    return <div className={s.loaderWrapper}><span className={s.loader}></span></div>
});
    